const MICROSOFT_URL = 'https://graph.microsoft.com/v1.0';
// Dev Url
const dev = process.env.REACT_APP_API_URL ? false : true;
const apiURLDEV = dev ? "http://localhost:3001" : "https://api.portal.zotac.service4k.com"
const portalURLDEV = dev ? "http://localhost:3000" : "https://portal.zotac.service4k.com"
// 
const API_URL = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : `${apiURLDEV}/wapi`;
const accessToken = localStorage.getItem('microsoftJWT') || '';
const REACT_APP_SSO_BACKEND = process.env.REACT_APP_SSO_BACKEND
  ? process.env.REACT_APP_SSO_BACKEND
  : apiURLDEV
const API_URL_PREFIX = process.env.REACT_APP_SSO_BACKEND
  ? process.env.REACT_APP_SSO_BACKEND
  : apiURLDEV


const env = {
  MICROSOFT_URL,
  API_URL,
  accessToken,
  REACT_APP_SSO_BACKEND,
  API_URL_PREFIX,
};

export default env;
